import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCategory } from "../../services/categories";
import { toast } from "react-toastify";

const useDeleteCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteCategory,

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["categories"] });
                toast.success('Category deleted successfully')
            }
        },

        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteCategory;